import { type CacheState } from './state';
import _ from 'lodash';

export const setCacheState = <T>(data: T | null, isLoading: boolean, hasError: boolean) => ({
  isLoading,
  hasError,
  data,
});

const addCache = (state: CacheState, payload: Record<string, unknown>) => {
  return {
    ...state,
    [_.keys(payload)[0]]: setCacheState(_.values(payload)[0], false, false),
  };
};

const invalidateCache = (state: CacheState, key: string) => {
  return {
    ...state,
    [key]: setCacheState(null, true, false),
  };
};

const errorCache = (state: CacheState, key: string) => {
  return {
    ...state,
    [key]: setCacheState(null, false, true),
  };
};

const reducers = {
  addCache,
  invalidateCache,
  errorCache,
};

export default reducers;
